import { atom } from 'jotai';
const sessionAtom = atom({
    user: null,
    quizId: null,
    crosswordId: null,
    duration: null,
    questions: [],
    words: [],
    submitted: false,
});
export { sessionAtom };
